import React from "react";
import { useBilling } from "../store/BillingContext";
import { Card } from "../components/common/Card";
import { DocumentTable } from "../components/documents/DocumentTable";
import { money } from "../lib/utils";

export const DashboardView: React.FC = () => {
  const { state, setView, setActiveDoc, openNewDocument, setActiveForm, loadDemoData } = useBilling();

  const invoices = state.invoices;
  const quotes = state.quotes;

  const paidRevenue = invoices
    .filter((x) => x.status === "paid")
    .reduce((sum, x) => sum + (Number(x.total) || 0), 0);

  const outstanding = invoices
    .filter((x) => !["paid", "cancelled"].includes(x.status))
    .reduce((sum, x) => sum + (Number(x.total) || 0), 0);

  const recentInvoices = invoices.slice(0, 5);

  return (
    <>
      <section className="cards">
        <Card
          title="Paid Revenue"
          value={money(paidRevenue)}
          icon="fa-indian-rupee-sign"
          subtitle="Realized business collections"
        />
        <Card
          title="Outstanding"
          value={money(outstanding)}
          icon="fa-hourglass-half"
          subtitle="Pending customer payments"
        />
        <Card
          title="Invoices"
          value={String(invoices.length)}
          icon="fa-file-invoice"
          subtitle={`${invoices.filter((i) => i.status === "paid").length} settled`}
        />
        <Card
          title="Quotations"
          value={String(quotes.length)}
          icon="fa-file-lines"
          subtitle={`${quotes.filter((q) => q.status === "accepted").length} accepted`}
        />
      </section>

      <section className="columns">
        <div className="panel">
          <div className="panel-title">
            <h3>Recent Invoices</h3>
            <button onClick={() => setView("invoices")}>
              View All Invoices →
            </button>
          </div>

          <DocumentTable docs={recentInvoices} onEdit={setActiveDoc} />
        </div>

        <div className="panel quick">
          <h3>Quick Business Actions</h3>
          <button className="primary" onClick={() => openNewDocument("invoice")}>
            <i className="fa-solid fa-file-circle-plus" /> Create Tax Invoice
          </button>
          <button className="gold" onClick={() => openNewDocument("quote")}>
            <i className="fa-solid fa-paper-plane" /> Create Quotation
          </button>
          <button
            onClick={() =>
              setActiveForm({
                kind: "client",
                value: { id: "", name: "", company: "", email: "", phone: "", address: "", gstin: "", industry: "" },
              })
            }
          >
            <i className="fa-solid fa-user-plus" /> Add New Client
          </button>
          <button onClick={() => setView("services")}>
            <i className="fa-solid fa-list-check" /> Manage Rate Card
          </button>
          <button onClick={() => setView("expenses")}>
            <i className="fa-solid fa-receipt" /> Record Business Expense
          </button>
          <button onClick={loadDemoData} style={{ marginTop: "10px", borderColor: "#cbd5e1", color: "#475569" }}>
            <i className="fa-solid fa-arrows-rotate" /> Reload Seed Invoices
          </button>
        </div>
      </section>
    </>
  );
};
